import { sdk } from '../../../sdk';
import { ServerOptions } from '@commercetools/frontend-sdk/lib/types/cookieHandling/ServerOptions';

interface RouteById {
  id: string;
  parameters?: {
    [parameter: string]: string | boolean | number | undefined;
  };
}

interface RouteByPath {
  path: string;
  parameters?: {
    [parameter: string]: string | boolean | number | undefined;
  };
}

type Route = RouteById | RouteByPath;

interface ApiProxyResponseBody {
  body: string;
  statusCode: number;
  headers: Record<string, string>;
}

export const makeApiProxyRequest = async (
  route: Route,
  body?: string | null,
  method?: string,
  headers?: Record<string, string>,
  serverOptions?: ServerOptions,
): Promise<Response> => {
  const response = await sdk.callAction<ApiProxyResponseBody>({
    actionName: 'legacy-data/api-proxy',
    payload: {
      route,
      method: method ?? 'GET',
      headers: headers ?? {},
      body: body ?? null,
    },
    serverOptions,
  });

  if (response.isError !== false) {
    throw new Error(`Error in API Proxy request: ${response.error}`);
  }

  return new Response(response.data.body, { status: response.data.statusCode, headers: response.data.headers });
};
